
import React from "react";
import { User } from "@/context/AuthContext";
import NotificationActions from "./NotificationActions";
import ArchiveRestoreActions from "./ArchiveRestoreActions";
import DeleteNotificationButton from "./DeleteNotificationButton";
import SendWebhookButton from "./detail/SendWebhookButton";

interface NotificationDetailHeaderProps {
  editMode: boolean;
  showEditHistory: boolean;
  setEditMode: (editMode: boolean) => void;
  setShowEditHistory: (show: boolean) => void;
  resetNotification: () => void;
  isPending: boolean;
  isArchived: boolean;
  onRestore: () => void;
  onArchive: () => void;
  onDelete: () => void;
  restorePending: boolean;
  archivePending: boolean;
  deletePending: boolean;
  handleSubmit: (e: React.FormEvent) => void;
  currentUser?: User | null;
  canEdit?: boolean;
  canDelete?: boolean;
  notification?: any;
}

const NotificationDetailHeader = ({
  editMode,
  showEditHistory,
  setEditMode,
  setShowEditHistory,
  resetNotification,
  isPending,
  isArchived,
  onRestore,
  onArchive,
  onDelete,
  restorePending,
  archivePending,
  deletePending,
  handleSubmit,
  currentUser,
  canEdit,
  canDelete,
  notification
}: NotificationDetailHeaderProps) => {
  return (
    <div className="flex flex-col gap-3 sm:gap-4">
      <div className="text-lg sm:text-xl font-semibold">
        {isArchived ? "Gearchiveerde Melding" : "Melding Details"}
        {currentUser && (
          <div className="text-sm font-normal text-muted-foreground">
            Ingelogd als: {currentUser.name}
          </div>
        )}
      </div>
      <div className="flex flex-col gap-2 w-full sm:w-auto">
        {!editMode && notification?.id && (
          <SendWebhookButton 
            notificationId={notification.id} 
            disabled={isArchived}
          />
        )}
        
        <NotificationActions 
          editMode={editMode}
          showEditHistory={showEditHistory}
          setEditMode={setEditMode}
          setShowEditHistory={setShowEditHistory}
          resetNotification={resetNotification}
          isPending={isPending}
          handleSubmit={handleSubmit}
        />
        
        <div className="flex gap-2">
          <ArchiveRestoreActions 
            isArchived={isArchived}
            onRestore={onRestore}
            onArchive={onArchive}
            restorePending={restorePending}
            archivePending={archivePending}
          />
          
          <DeleteNotificationButton 
            onDelete={onDelete} 
            isLoading={deletePending} 
            isArchived={isArchived}
          />
        </div>
      </div>
    </div>
  );
};

export default NotificationDetailHeader;
